module.exports = __webpack_public_path__ + "49008d6a85fe952be8f702d722472bc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/news/img1_1.jpg
// module id = 366
// module chunks = 0